import { render, staticRenderFns } from "./Lbs.vue?vue&type=template&id=7efd45e2"
import script from "./Lbs.vue?vue&type=script&lang=ts"
export * from "./Lbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports